import script from "./WidgetHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetHeader.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetHeader.vue?vue&type=style&index=0&id=1cef5bc9&lang=scss"

const __exports__ = script;

export default __exports__